<script>

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import TrackersTable from './TrackersTable';


export default {
  page: {
    title: 'Trackers',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, TrackersTable },
  data() {
    return {
      title: 'Trackers',
      items: [
        { text: appConfig.title, to: '/', },
        { text: 'Trackers', active: true, },
      ],

      loading: true,
      filters: {
        whereins: {
          website: [],
        },
      },
    }
  },
  created() {
    this.filters.whereins.website = [this.website_id];
  },
  methods: {

  }
}
</script>

<template>
  <Layout>
    <router-view v-show="$route.params.id" :key="$route.fullPath"></router-view>

    <div v-show="!$route.params.id">

      <PageHeader :title="title" :items="items" />

      <div class="row mt-4">
        <div class="col-12">
          <div class="card-box p-0 position-relative">
            <TrackersTable ref="TrackersTable" :changefilters="filters"  @loadchange="(e) => {loading = e;}"></TrackersTable>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

